<div class="row">
  <div class="col-md-12 checkbox d-flex justify-content-end mb-3 mt-4">
    <label>
      <input
        id="selectAllPermissionsAppointments"
        [(ngModel)]="
          permissionAppointments.selectAllPermissionAppointments.Selected
        "
        class="cc-filter-checkbox set-pointer-events"
        type="checkbox"
        kendoCheckBox
        [disabled]="
          isUkgDefaultGroup || isViewOnly || !disabledSelectAllAppointments
        "
        (change)="valueChangeByselectAllPermissionsAppointment($event)"
      />
      {{ "_Permission_Select_All_Appointment_Permissions_" | translate }}
    </label>
  </div>
  <ng-container *ngIf="isLoaded">
    <!-- 
    <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="group-title">Reports</div>
            <div class="checkbox d-flex justify-content-center">
                <label>
                    <input id="" (change)="aCReportsSelectAllchange()" name="
                    aCReportsSelectAll" [(ngModel)]="aCReportsSelectAll" class="cc-filter-checkbox" type="checkbox"
                        kendoCheckBox />
                    Select All
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="checkbox">
                    <label>
                        <input id=""
                            (change)="changeviewAppointmentDetailAndAppointmentTrendReports(permissionAppointments.viewAppointmentDetailAndAppointmentTrendReports)"
                            name="
                        viewAppointmentDetailAndAppointmentTrendReports"
                            [(ngModel)]="permissionAppointments.viewAppointmentDetailAndAppointmentTrendReports"
                            class="cc-filter-checkbox" type="checkbox" kendoCheckBox />
                        View Appointment Detail and Appointment Trend Reports
                    </label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="checkbox">
                    <label>
                        <input id="" (change)="changeviewCampaignReport(permissionAppointments.viewCampaignReport)" name="
                        viewCampaignReport" [(ngModel)]="permissionAppointments.viewCampaignReport"
                            class="cc-filter-checkbox" type="checkbox" kendoCheckBox />
                        View Campaign Report
                    </label>
                </div>
            </div>
        </div>
    </div> -->
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{
              "_Permission_Appointment_Administration_Title_Text_" | translate
            }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="admin_select_all"
                [(ngModel)]="permissionAppointments.Administration.selectAll"
                (change)="onAdminSelectAll()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.Administration.ViewEditAdministration
                    .Enabled ||
                  !permissionAppointments.Administration.ViewEditEventSettings
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="67"
                  name="admin_view"
                  (change)="onAdminSettingsChanged()"
                  [(ngModel)]="
                    permissionAppointments.Administration.ViewEditAdministration
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Administration
                      .ViewEditAdministration.Enabled
                  "
                />
                {{
                  permissionAppointments.Administration.ViewEditAdministration
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="80"
                    name="admin_view_edit_event_settings"
                    (change)="onAdminSettingsChanged()"
                    [(ngModel)]="
                      permissionAppointments.Administration
                        .ViewEditEventSettings.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Administration
                        .ViewEditEventSettings.Enabled ||
                      !permissionAppointments.Administration
                        .ViewEditAdministration.Selected
                    "
                  />
                  {{
                    permissionAppointments.Administration.ViewEditEventSettings
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Appointments_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="appSAll"
                [(ngModel)]="permissionAppointments.Appointements.selectAll"
                (change)="selectAllGeneral()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.Appointements.appointmentsView
                    .Enabled ||
                  !permissionAppointments.Appointements.appointmentsEdit
                    .Enabled ||
                  !permissionAppointments.Appointements.appointmentsDelete
                    .Enabled ||
                  !permissionAppointments.Appointements.ExceptionsAdd.Enabled ||
                  !permissionAppointments.Appointements.ExceptionsEdit
                    .Enabled ||
                  !permissionAppointments.Appointements.ExceptionsDelete
                    .Enabled ||
                  !permissionAppointments.Appointements.appointmentsAdd.Enabled
                "
                [checked]="
                  permissionAppointments.Appointements.appointmentsView
                    .Selected &&
                  permissionAppointments.Appointements.appointmentsEdit
                    .Selected &&
                  permissionAppointments.Appointements.appointmentsDelete
                    .Selected &&
                  permissionAppointments.Appointements.ExceptionsAdd.Selected &&
                  permissionAppointments.Appointements.ExceptionsEdit
                    .Selected &&
                  permissionAppointments.Appointements.ExceptionsDelete
                    .Selected &&
                  permissionAppointments.Appointements.appointmentsAdd.Selected
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="35"
                  name="aVS"
                  (change)="onAppointmentsItemChange()"
                  [(ngModel)]="
                    permissionAppointments.Appointements.appointmentsView
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Appointements.appointmentsView
                      .Enabled
                  "
                />
                {{
                  permissionAppointments.Appointements.appointmentsView
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="69"
                    name="aEd"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.appointmentsAdd
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.appointmentsAdd
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.appointmentsAdd
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="36"
                    name="aEd"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.appointmentsEdit
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.appointmentsEdit
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.appointmentsEdit
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="37"
                    name="aDS"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.appointmentsDelete
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.appointmentsDelete
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.appointmentsDelete
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="my-3 sub-heading-dependent">
                {{
                  "_Permission_Appointment_Exceptions_Title_Text_" | translate
                }}
              </div>

              <div class="checkbox">
                <label>
                  <input
                    id="38"
                    name="ExAdd"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.ExceptionsAdd
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.ExceptionsAdd
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.ExceptionsAdd
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="39"
                    name="ExEdi"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.ExceptionsEdit
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.ExceptionsEdit
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.ExceptionsEdit
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="40"
                    name="ExDel"
                    (change)="onAppointmentsItemChange()"
                    [(ngModel)]="
                      permissionAppointments.Appointements.ExceptionsDelete
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Appointements.ExceptionsDelete
                        .Enabled ||
                      !permissionAppointments.Appointements.appointmentsView
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.Appointements.ExceptionsDelete
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Appointment_Action_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="acSAll"
                [(ngModel)]="permissionAppointments.ViewActionCenter.selectAll"
                (change)="selectAllActionCenter()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.ViewActionCenter.viewActionCenter
                    .Enabled ||
                  !permissionAppointments.ViewActionCenter.editActionCenter
                    .Enabled ||
                  !permissionAppointments.ViewActionCenter
                    .changeAppointmentAssignment.Enabled ||
                  !permissionAppointments.ViewActionCenter.sendFollowUpEnable
                    .Enabled ||
                  !permissionAppointments.ViewActionCenter
                    .bulkDeleteAppointments.Enabled ||
                  !permissionAppointments.ViewActionCenter
                    .changeAppointmentStatus.Enabled
                "
                [checked]="
                  permissionAppointments.ViewActionCenter.viewActionCenter
                    .Selected &&
                  permissionAppointments.ViewActionCenter.editActionCenter
                    .Selected &&
                  permissionAppointments.ViewActionCenter
                    .changeAppointmentAssignment.Selected &&
                  permissionAppointments.ViewActionCenter.sendFollowUpEnable
                    .Selected &&
                  permissionAppointments.ViewActionCenter.bulkDeleteAppointments
                    .Selected &&
                  permissionAppointments.ViewActionCenter
                    .changeAppointmentStatus.Selected
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="41"
                  name="vAC"
                  (change)="onActionCenterItemChange()"
                  [(ngModel)]="
                    permissionAppointments.ViewActionCenter.viewActionCenter
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.ViewActionCenter.viewActionCenter
                      .Enabled
                  "
                />
                {{
                  permissionAppointments.ViewActionCenter.viewActionCenter
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="42"
                    name="eAC"
                    (change)="onActionCenterItemChange()"
                    [(ngModel)]="
                      permissionAppointments.ViewActionCenter.editActionCenter
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.ViewActionCenter.editActionCenter
                        .Enabled ||
                      !permissionAppointments.ViewActionCenter.viewActionCenter
                        .Selected
                    "
                  />
                  {{
                    permissionAppointments.ViewActionCenter.editActionCenter
                      .DisplayName | translate
                  }}
                </label>
              </div>
              <div class="tab-indent mt-1">
                <div class="checkbox">
                  <label>
                    <input
                      id="45"
                      name="bADe"
                      (change)="onActionCenterItemChange()"
                      [(ngModel)]="
                        permissionAppointments.ViewActionCenter
                          .bulkDeleteAppointments.Selected
                      "
                      class="cc-filter-checkbox"
                      type="checkbox"
                      kendoCheckBox
                      [disabled]="
                        !permissionAppointments.ViewActionCenter
                          .bulkDeleteAppointments.Enabled ||
                        !permissionAppointments.ViewActionCenter
                          .viewActionCenter.Selected ||
                        !permissionAppointments.ViewActionCenter
                          .editActionCenter.Selected
                      "
                    />
                    {{
                      permissionAppointments.ViewActionCenter
                        .bulkDeleteAppointments.DisplayName | translate
                    }}
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input
                      id="43"
                      name="cAassingnment"
                      (change)="onActionCenterItemChange()"
                      [(ngModel)]="
                        permissionAppointments.ViewActionCenter
                          .changeAppointmentAssignment.Selected
                      "
                      class="cc-filter-checkbox"
                      type="checkbox"
                      kendoCheckBox
                      [disabled]="
                        !permissionAppointments.ViewActionCenter
                          .changeAppointmentAssignment.Enabled ||
                        !permissionAppointments.ViewActionCenter
                          .viewActionCenter.Selected ||
                        !permissionAppointments.ViewActionCenter
                          .editActionCenter.Selected
                      "
                    />
                    {{
                      permissionAppointments.ViewActionCenter
                        .changeAppointmentAssignment.DisplayName | translate
                    }}
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input
                      id="84"
                      name="cAassingnment"
                      (change)="onActionCenterItemChange()"
                      [(ngModel)]="
                        permissionAppointments.ViewActionCenter
                          .changeAppointmentStatus.Selected
                      "
                      class="cc-filter-checkbox"
                      type="checkbox"
                      kendoCheckBox
                      [disabled]="
                        !permissionAppointments.ViewActionCenter
                          .changeAppointmentStatus.Enabled ||
                        !permissionAppointments.ViewActionCenter
                          .viewActionCenter.Selected ||
                        !permissionAppointments.ViewActionCenter
                          .editActionCenter.Selected
                      "
                    />
                    {{
                      permissionAppointments.ViewActionCenter
                        .changeAppointmentStatus.DisplayName | translate
                    }}
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input
                      id="44"
                      name="sFE"
                      (change)="onActionCenterItemChange()"
                      [(ngModel)]="
                        permissionAppointments.ViewActionCenter
                          .sendFollowUpEnable.Selected
                      "
                      class="cc-filter-checkbox"
                      type="checkbox"
                      kendoCheckBox
                      [disabled]="
                        !permissionAppointments.ViewActionCenter
                          .sendFollowUpEnable.Enabled ||
                        !permissionAppointments.ViewActionCenter
                          .viewActionCenter.Selected ||
                        !permissionAppointments.ViewActionCenter
                          .editActionCenter.Selected
                      "
                    />
                    {{
                      permissionAppointments.ViewActionCenter.sendFollowUpEnable
                        .DisplayName | translate
                    }}
                  </label>
                </div>
                <div
                  *ngIf="
                    !this.permissionAppointments.ViewActionCenter.isInputValid
                  "
                  class="cc-validation"
                >
                  {{ "_Permission_Appointment_Action_Validation_" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="group-title">System Settings</div>
            <div class="checkbox d-flex justify-content-center">
                <label>
                    <input id="" name="sysSettings" [(ngModel)]="permissionAppointments.SystemSettings.selectAll"
                        (change)="selectAllActionCenter()" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                        [disabled]="!permissionAppointments.SystemSettings.viewSystemSettings.Enabled
                        && !permissionAppointments.SystemSettings.editSystemSettings.Enabled" [checked]="permissionAppointments.SystemSettings.viewSystemSettings.Selected
                    && permissionAppointments.SystemSettings.editSystemSettings.Selected" />
                    Select All
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="checkbox">
                    <label>
                        <input id="1" name="sysSetEna" (change)="onSystemSettingsItemChange()"
                            [(ngModel)]="permissionAppointments.SystemSettings.viewSystemSettings.Selected"
                            class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                            [disabled]="!permissionAppointments.SystemSettings.viewSystemSettings.Enabled" />
                        {{permissionAppointments.SystemSettings.viewSystemSettings.DisplayName}}
                    </label>
                </div>
                <div class="tab-indent mt-1">
                    <div class="checkbox">
                        <label>
                            <input id="1" name="eDsysSetEna" (change)="onSystemSettingsItemChange()"
                                [(ngModel)]="permissionAppointments.SystemSettings.editSystemSettings.Selected"
                                class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                                [disabled]="!permissionAppointments.SystemSettings.editSystemSettings.Enabled" />
                            {{permissionAppointments.SystemSettings.editSystemSettings.DisplayName}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Appointment_Campaigns_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="campaigns_select_all"
                [(ngModel)]="permissionAppointments.Campaigns.selectAll"
                (change)="onCampaignsSelectAll()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.Campaigns.ViewCampaigns.Enabled ||
                  !permissionAppointments.Campaigns.EditCampaigns.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="67"
                  name="campaigns_view"
                  (change)="onCampaignsSettingsChanged()"
                  [(ngModel)]="
                    permissionAppointments.Campaigns.ViewCampaigns.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Campaigns.ViewCampaigns.Enabled
                  "
                />
                {{
                  permissionAppointments.Campaigns.ViewCampaigns.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="81"
                    name="campaigns_edit"
                    (change)="onCampaignsSettingsChanged()"
                    [(ngModel)]="
                      permissionAppointments.Campaigns.EditCampaigns.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Campaigns.EditCampaigns.Enabled ||
                      !permissionAppointments.Campaigns.ViewCampaigns.Selected
                    "
                  />
                  {{
                    permissionAppointments.Campaigns.EditCampaigns.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Appointment_Events_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="events_select_all"
                [(ngModel)]="permissionAppointments.Events.selectAll"
                (change)="onEventsSelectAll()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.Events.ViewEvents.Enabled ||
                  !permissionAppointments.Events.AddEvents.Enabled ||
                  !permissionAppointments.Events.EditEvents.Enabled ||
                  !permissionAppointments.Events.ActivateDeactivateEvents
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="67"
                  name="events_view"
                  (change)="onEventsSettingsChanged()"
                  [(ngModel)]="
                    permissionAppointments.Events.ViewEvents.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionAppointments.Events.ViewEvents.Enabled"
                />
                {{
                  permissionAppointments.Events.ViewEvents.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="80"
                    name="events_add"
                    (change)="onEventsSettingsChanged()"
                    [(ngModel)]="
                      permissionAppointments.Events.AddEvents.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Events.AddEvents.Enabled ||
                      !permissionAppointments.Events.ViewEvents.Selected
                    "
                  />
                  {{
                    permissionAppointments.Events.AddEvents.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="81"
                    name="events_edit"
                    (change)="onEventsSettingsChanged()"
                    [(ngModel)]="
                      permissionAppointments.Events.EditEvents.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Events.EditEvents.Enabled ||
                      !permissionAppointments.Events.ViewEvents.Selected
                    "
                  />
                  {{
                    permissionAppointments.Events.EditEvents.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="81"
                    name="events_activate_deactivate"
                    (change)="onEventsSettingsChanged()"
                    [(ngModel)]="
                      permissionAppointments.Events.ActivateDeactivateEvents
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionAppointments.Events.ActivateDeactivateEvents
                        .Enabled ||
                      !permissionAppointments.Events.ViewEvents.Selected
                    "
                  />
                  {{
                    permissionAppointments.Events.ActivateDeactivateEvents
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Check with AC team and Map accordingly -->
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Report_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="vADAAppoinTrend"
                [(ngModel)]="permissionAppointments.Reports.selectAll"
                (change)="selectAllReports()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionAppointments.Reports.viewAppointmentDetailsReport
                    .Enabled ||
                  !permissionAppointments.Reports.viewCampaignSummaryReport
                    .Enabled ||
                  !permissionAppointments.Reports.viewAppointmentTrendsReport
                    .Enabled
                "
                [checked]="
                  permissionAppointments.Reports.viewAppointmentDetailsReport
                    .Selected &&
                  permissionAppointments.Reports.viewCampaignSummaryReport
                    .Selected &&
                  permissionAppointments.Reports.viewAppointmentTrendsReport
                    .Selected
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="63"
                  name="trendReport"
                  (change)="onReportItemChange()"
                  [(ngModel)]="
                    permissionAppointments.Reports.viewAppointmentDetailsReport
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Reports.viewAppointmentDetailsReport
                      .Enabled
                  "
                />
                {{
                  permissionAppointments.Reports.viewAppointmentDetailsReport
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  id="64"
                  name="campReport"
                  (change)="onReportItemChange()"
                  [(ngModel)]="
                    permissionAppointments.Reports.viewAppointmentTrendsReport
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Reports.viewAppointmentTrendsReport
                      .Enabled
                  "
                />
                {{
                  permissionAppointments.Reports.viewAppointmentTrendsReport
                    .DisplayName | translate
                }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  id="64"
                  name="campReport"
                  (change)="onReportItemChange()"
                  [(ngModel)]="
                    permissionAppointments.Reports.viewCampaignSummaryReport
                      .Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionAppointments.Reports.viewCampaignSummaryReport
                      .Enabled
                  "
                />
                {{
                  permissionAppointments.Reports.viewCampaignSummaryReport
                    .DisplayName | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
